import React from "react";
import StaticPageLayout from "./StaticPageLayout";

const EMAIL = "contact@arcanechronicles.com";
const UPDATED = "2026-04-23";

export default function PrivacyPolicy() {
  return (
    <StaticPageLayout titleIt="Informativa sulla Privacy" titleEn="Privacy Policy">
      {(isIt) => (
        <>
          <p className="text-xs text-[#94a3b8]">{isIt ? "Ultimo aggiornamento" : "Last updated"}: {UPDATED}</p>
          {isIt ? (
            <>
              <h2 className="font-heading text-xl text-[#cfb53b] mt-4">1. Titolare del trattamento</h2>
              <p>Il titolare del trattamento dei dati personali è il gestore di Arcane Chronicles, contattabile all'indirizzo <a className="text-[#cfb53b]" href={`mailto:${EMAIL}`}>{EMAIL}</a>.</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">2. Dati raccolti</h2>
              <p>Raccogliamo solo i dati strettamente necessari al funzionamento del gioco:</p>
              <ul className="list-disc pl-5">
                <li><strong>Email</strong>: per la registrazione e il login all'account.</li>
                <li><strong>Password</strong>: conservata in forma crittografata (hash bcrypt). Non abbiamo mai accesso alla password in chiaro.</li>
                <li><strong>Dati di gioco</strong>: personaggi, scelte narrative, carte collezionate, statistiche di partita.</li>
                <li><strong>Log tecnici</strong>: timestamp di accesso e azioni, modelli IA utilizzati per prevenire abusi.</li>
                <li><strong>Dati di pagamento</strong> (se effettui acquisti): gestiti interamente da Stripe. Noi conserviamo solo l'ID della transazione e lo stato.</li>
              </ul>

              <h2 className="font-heading text-xl text-[#cfb53b]">3. Finalità del trattamento</h2>
              <ul className="list-disc pl-5">
                <li>Erogazione del servizio di gioco.</li>
                <li>Sicurezza dell'account e prevenzione frodi.</li>
                <li>Miglioramento dell'app tramite analisi aggregate.</li>
                <li>Gestione pagamenti tramite Stripe.</li>
              </ul>

              <h2 className="font-heading text-xl text-[#cfb53b]">4. Base giuridica</h2>
              <p>Il trattamento è basato sull'esecuzione di un contratto (Termini di Servizio accettati al momento della registrazione) e sul legittimo interesse del titolare a garantire la sicurezza del servizio.</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">5. Servizi di terze parti</h2>
              <p>Il gioco utilizza i seguenti servizi di terze parti che trattano dati:</p>
              <ul className="list-disc pl-5">
                <li><strong>Emergent (Universal LLM Key)</strong>: per generare testo e immagini. I prompt contengono descrizioni narrative del tuo personaggio, non la tua email.</li>
                <li><strong>Google Gemini</strong> e <strong>OpenAI</strong>: provider IA sottostanti. Consulta le rispettive privacy policy.</li>
                <li><strong>Cloudinary</strong>: CDN per la persistenza delle immagini generate.</li>
                <li><strong>Stripe</strong>: gestione pagamenti (se attiva).</li>
              </ul>

              <h2 className="font-heading text-xl text-[#cfb53b]">6. Cookie</h2>
              <p>Vedi la <a className="text-[#cfb53b]" href="/cookies">Cookie Policy</a> per dettagli.</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">7. Conservazione</h2>
              <p>I dati di gioco sono conservati finché mantieni l'account attivo. Puoi richiedere la cancellazione del tuo account scrivendo a <a className="text-[#cfb53b]" href={`mailto:${EMAIL}`}>{EMAIL}</a>.</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">8. I tuoi diritti (GDPR)</h2>
              <p>Hai diritto di: accedere ai tuoi dati, chiederne la rettifica, la cancellazione, la limitazione del trattamento, la portabilità, e opporti al trattamento. Per esercitare questi diritti scrivi a <a className="text-[#cfb53b]" href={`mailto:${EMAIL}`}>{EMAIL}</a>.</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">9. Sicurezza</h2>
              <p>Adottiamo misure tecniche e organizzative adeguate (HTTPS, hash password con bcrypt, limitazione accessi, backup). Nessun sistema è totalmente sicuro: ti consigliamo di usare una password forte e univoca.</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">10. Minori</h2>
              <p>Il gioco è destinato a utenti di almeno 13 anni. Se hai meno di 16 anni e ti trovi in UE, è necessario il consenso dei genitori/tutore legale.</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">11. Modifiche</h2>
              <p>Questa policy può essere aggiornata. Ti notificheremo cambiamenti sostanziali tramite email o avviso in-app.</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">12. Contatti</h2>
              <p>Per qualsiasi questione relativa alla privacy: <a className="text-[#cfb53b]" href={`mailto:${EMAIL}`}>{EMAIL}</a></p>
            </>
          ) : (
            <>
              <h2 className="font-heading text-xl text-[#cfb53b] mt-4">1. Data Controller</h2>
              <p>The data controller for personal data is the operator of Arcane Chronicles, reachable at <a className="text-[#cfb53b]" href={`mailto:${EMAIL}`}>{EMAIL}</a>.</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">2. Data We Collect</h2>
              <ul className="list-disc pl-5">
                <li><strong>Email</strong>: account registration and login.</li>
                <li><strong>Password</strong>: stored encrypted (bcrypt hash). We never access the plaintext password.</li>
                <li><strong>Game data</strong>: characters, choices, collected cards, statistics.</li>
                <li><strong>Technical logs</strong>: access timestamps and actions, AI models used to prevent abuse.</li>
                <li><strong>Payment data</strong> (if you purchase): fully handled by Stripe. We only store the transaction ID and status.</li>
              </ul>

              <h2 className="font-heading text-xl text-[#cfb53b]">3. Purposes</h2>
              <ul className="list-disc pl-5">
                <li>Providing the game service.</li>
                <li>Account security and fraud prevention.</li>
                <li>Aggregate analytics to improve the app.</li>
                <li>Payment processing via Stripe.</li>
              </ul>

              <h2 className="font-heading text-xl text-[#cfb53b]">4. Legal Basis</h2>
              <p>Processing is based on contract execution (Terms of Service accepted at registration) and the controller's legitimate interest in ensuring service security.</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">5. Third-party Services</h2>
              <ul className="list-disc pl-5">
                <li><strong>Emergent (Universal LLM Key)</strong>: for text and image generation. Prompts contain narrative descriptions, not your email.</li>
                <li><strong>Google Gemini</strong> and <strong>OpenAI</strong>: underlying AI providers. See their respective privacy policies.</li>
                <li><strong>Cloudinary</strong>: CDN for generated image persistence.</li>
                <li><strong>Stripe</strong>: payment processing (when enabled).</li>
              </ul>

              <h2 className="font-heading text-xl text-[#cfb53b]">6. Cookies</h2>
              <p>See the <a className="text-[#cfb53b]" href="/cookies">Cookie Policy</a> for details.</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">7. Retention</h2>
              <p>Game data is retained as long as your account is active. You can request account deletion by writing to <a className="text-[#cfb53b]" href={`mailto:${EMAIL}`}>{EMAIL}</a>.</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">8. Your Rights (GDPR)</h2>
              <p>You have the right to: access your data, request correction, deletion, restriction of processing, portability, and object to processing. To exercise these rights write to <a className="text-[#cfb53b]" href={`mailto:${EMAIL}`}>{EMAIL}</a>.</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">9. Security</h2>
              <p>We use appropriate technical and organizational measures (HTTPS, bcrypt password hashing, access limitation, backups). No system is completely secure: we recommend using a strong and unique password.</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">10. Minors</h2>
              <p>The game is intended for users aged 13 and over. If you are under 16 and in the EU, parent/legal guardian consent is required.</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">11. Changes</h2>
              <p>This policy may be updated. We will notify substantial changes via email or in-app notice.</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">12. Contact</h2>
              <p>For any privacy-related matter: <a className="text-[#cfb53b]" href={`mailto:${EMAIL}`}>{EMAIL}</a></p>
            </>
          )}
        </>
      )}
    </StaticPageLayout>
  );
}
